import React from "react";
import styles from "./Card.module.css";
import { Link } from "react-router-dom";

function Card({ product }) {
  return (
    <div className="col-sm-12 col-md-6 col-lg-3">
      <Link to={`/product/${product.slug}`} className={styles.link}>
        <div className={styles.card}>
          <img className={styles.img} src={product.image} alt="" />
          <h2 className={styles.name}>{product.name}</h2>
          <h4 className={styles.subtitle}>{product.type}</h4>
          <div>
            <span className={styles.price}>US$ {product.price}</span>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default Card;
